import React from "react";
import { MyAppsHub } from "@/components/MyAppsHub";
import { SEOHead } from "@/components/SEOHead";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const MyApps = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return null;
  }

  if (!user) {
    return null;
  }

  return (
    <>
      <SEOHead
        title="My Apps | DayOne"
        description="Manage and build your apps with AI"
      />
      <MyAppsHub />
    </>
  );
};

export default MyApps;
